var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Crown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.4766 8.5125C22.4766 8.52281 22.4766 8.53219 22.47 8.5425L20.3437 18.2803C20.2783 18.6232 20.0953 18.9325 19.8263 19.155C19.5573 19.3775 19.2191 19.4991 18.87 19.4991H5.12905C4.78013 19.4989 4.44217 19.3772 4.17335 19.1547C3.90452 18.9323 3.72166 18.623 3.65624 18.2803L1.52999 8.5425C1.52999 8.53219 1.5253 8.52281 1.52343 8.5125C1.46523 8.19009 1.51419 7.8575 1.66283 7.56554C1.81146 7.27358 2.05159 7.03831 2.34653 6.89568C2.64146 6.75305 2.97499 6.71089 3.29613 6.77567C3.61728 6.84044 3.9084 7.00857 4.12499 7.25437L7.28155 10.6566L10.6378 3.12937C10.638 3.12625 10.638 3.12312 10.6378 3.12C10.7578 2.8597 10.9499 2.63923 11.1913 2.4847C11.4327 2.33017 11.7134 2.24805 12 2.24805C12.2866 2.24805 12.5673 2.33017 12.8087 2.4847C13.0501 2.63923 13.2422 2.8597 13.3622 3.12C13.362 3.12312 13.362 3.12625 13.3622 3.12937L16.7184 10.6566L19.875 7.25437C20.092 7.01039 20.3828 6.84391 20.703 6.78019C21.0233 6.71648 21.3556 6.75902 21.6495 6.90135C21.9434 7.04369 22.1828 7.27804 22.3314 7.56882C22.48 7.85961 22.5297 8.19094 22.4728 8.5125H22.4766Z",
    fill: "url(#paint0_linear_9960_483)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9960_483",
    x1: 1.49957,
    y1: 3.70443,
    x2: 4.84354,
    y2: 23.0791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4675FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05D6B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/Crown.6e4ca51ea793e5dada90bd16fe85e962.svg";
export { ForwardRef as ReactComponent };